import { render, staticRenderFns } from "./sms-opt-in-login-create.vue?vue&type=template&id=ce5408c8&scoped=true&"
import script from "./sms-opt-in-login-create.vue?vue&type=script&lang=js&"
export * from "./sms-opt-in-login-create.vue?vue&type=script&lang=js&"
import style0 from "./sms-opt-in-login-create.vue?vue&type=style&index=0&id=ce5408c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5408c8",
  null
  
)

export default component.exports